import { render, staticRenderFns } from "./ProductCardsMain.vue?vue&type=template&id=2779da09&"
import script from "./ProductCardsMain.vue?vue&type=script&lang=js&"
export * from "./ProductCardsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports